import { createRequest } from '@/utils/request'

const request = createRequest({})

export async function IgetPositionPUN({ lng, lat }: any) {
  return request.post('/nddt/portal/server/api/httpForward/lx_uav_api', {
    url:
      `${window.SystemConfig.rightNavCtrlConfig.dataApiUrl8765
        }/services/lxpf/address/coord?serviceKey=tmiKPqf1niMu5rq1VcG49XKIYmhwDJEh&lat=${lat}&lng=${lng}`,
  })
}
